import { forwardRef, ReactNode } from 'react';
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';

export interface BoxProps extends MuiBoxProps {
  children?: ReactNode;
}

export const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ children, ...props }, ref) => {
    return (
      <MuiBox ref={ref} {...props}>
        {children}
      </MuiBox>
    );
  },
);

Box.displayName = 'Box';
